import { render, staticRenderFns } from "./AffiliateInvoices.vue?vue&type=template&id=00ac0b96&scoped=true"
import script from "./AffiliateInvoices.vue?vue&type=script&lang=js"
export * from "./AffiliateInvoices.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/login.css?vue&type=style&index=0&id=00ac0b96&prod&scoped=true&lang=css&external"
import style1 from "./AffiliateInvoices.vue?vue&type=style&index=1&id=00ac0b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ac0b96",
  null
  
)

export default component.exports